<template>
  <div class="subPageNavigator">
    <Logo class="standAlone" v-if="isHeader" />
    <router-link to="/" class="link back" v-if="home">
      <ArrowAsBack />
      <Logo class="hideOnMobile" />
    </router-link>

    <router-link v-bind:to="back.path" class="link back" v-if="back">
      <ArrowAsBack />
      <strong class>{{ back.number }}</strong>
      <span class="ArrowAsLink">{{ back.label }}</span>
    </router-link>

    <router-link v-bind:to="next.path" class="link next" v-if="next">
      <strong>{{ next.number }}</strong>
      <span class="ArrowAsLink">{{ next.label }}</span>
      <ArrowAsLink />
    </router-link>
  </div>
</template>
<script>
import ArrowAsBack from "../ArrowAsBack.vue";
import ArrowAsLink from "../ArrowAsLink.vue";
import Logo from "../Logo.vue";
export default {
  name: "SubPageNavigator",
  components: {
    ArrowAsBack,
    ArrowAsLink,
    Logo
  },
  props: {
    back: Object,
    next: Object,
    home: Boolean,
    isHeader: Boolean
  }
};
</script>
<style scoped>
header .subPageNavigator {
  margin-top: var(--LINE-HEIGHT);
}
@media only screen and (max-width: 576px) {
  header .subPageNavigator {
    margin-top: calc(var(--LINE-HEIGHT) / 2);
  }
}

.subPageNavigator {
  display: flex;
  justify-content: space-between;
  vertical-align: top;
  font-size: 0;
  position: relative;
  min-height: var(--LINE-HEIGHT);
}

@media only screen and (max-width: 576px) {
  .subPageNavigator {
    padding-top: var(--LINE-HEIGHT);
    line-height: calc(var(--LINE-HEIGHT) * 2);
    width: 100%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .subPageNavigator {
    line-height: calc(var(--LINE-HEIGHT) * 2);
    width: 100%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .subPageNavigator {
    line-height: calc(var(--LINE-HEIGHT) * 2);
    width: 660px;
  }
}
@media only screen and (min-width: 992px) {
  .subPageNavigator {
    line-height: calc(var(--LINE-HEIGHT) * 2);
    width: 758px;
  }
}

.back,
.next {
  display: inline-block;
  font-size: 0;
}

.next {
  align-self: flex-end;
}

.back .logo,
.back svg,
.next svg {
  display: inline-block;
  vertical-align: top;
  /* background: green; */
}

.back .logo {
  margin-left: 10px;
}

header .logo.standAlone {
  display: none;
}

@media only screen and (max-width: 576px) {
  .back {
    --left: -3px;
    --right: 0;
  }

  .back .hideOnMobile {
    display: none;
  }
  header .logo.standAlone {
    position: absolute !important;
    display: block;
    margin-left: 0;
    left: 75px;
    right: auto;
    top: 0;
  }

  .back,
  .next {
    padding-top: 2px;
    position: relative;
    font-size: 18px;
  }

  .link svg.ArrowAsLink,
  .link svg.ArrowAsBack {
    position: absolute;
    top: calc(var(--LINE-HEIGHT) * -1);
  }

  .link svg.ArrowAsLink {
    right: -2px;
  }
  .link svg.ArrowAsBack {
    left: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .back {
    --left: 0;
    --right: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .back {
    --left: 0;
    --right: auto;
    --bottom: 0;
  }
}
@media only screen and (min-width: 992px) {
  .back {
    --left: -14px;
    --right: auto;
  }
}
.back {
  margin-left: var(--left);
}

.link {
  vertical-align: top;
  z-index: 10;
  line-height: calc(var(--LINE-HEIGHT) * 2);
  font-size: 20px;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  display: inline-block;
}

@media only screen and (max-width: 576px) {
  .link {
    font-size: 18px;
  }
}

.link strong {
  font-weight: bold;
  margin-right: 25px;
  display: inline-block;
}

.link span {
  transition: var(--TRANSITION);
  display: inline-block;
  text-decoration: underline;
  text-decoration-thickness: 1.5px;
}

.link svg.ArrowAsLink {
  margin-left: 20px;
}
.link svg.ArrowAsBack {
  margin-right: 20px;
}

.link.back svg,
.link.back strong,
.link.back .logo,
.link.back span,
.link.next svg,
.link.next strong,
.link.next .logo,
.link.next span {
  transition: var(--TRANSITION);
}

.link.back:hover svg,
.link.back:hover strong,
.link.back:hover .logo,
.link.back:hover span {
  transform: translateX(-10px);
}

.link.next:hover svg,
.link.next:hover strong,
.link.next:hover span {
  transform: translateX(10px);
}

.link:hover span {
  text-decoration-thickness: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/SubPageNavigator.vue